<template>
  <Tab @close="removeCurrent">
    <template #toolbar-items>
      <!-- ------------------------ user ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'user'"
        icon="fa-cogs"
        name="user"
      ></TabToolbarButton>
      <!-- ------------------------ secret ------------------------ -->
      <TabToolbarButton v-if="false"
        v-model="page"
        :menu="menu"
        :selected="page === 'secret'"
        icon="fa-key"
        name="secret"
      ></TabToolbarButton>
      <!-- ------------------------ bookmarks / favoris ------------------------ -->
      <TabToolbarButton v-if="false"
          v-model="page"
          :menu="menu"
          :selected="page === 'bookmark'"
          icon="fa-bookmark"
          name="bookmark"
      ></TabToolbarButton>
    </template>
    <template #container>
      <!-- ------------------------ user ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="me/account/user" name="user">
        <template #content>
          <!-- Form to update user data -->
          <Form ref="account" :callback="update">
            <AvatarField
              v-if="user.hasOwnProperty('avatar')"
              :src="
                user.avatar
                  ? user.avatar
                  : 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'
              "
              i18n="account.form.avatar"
              with-upload
              @uploaded="updateUserAvatar"
            />
            <FormField v-model="user.user_name" i18n="account.form.user_name" input-type="text" />

            <FormField v-model="user.first_name" i18n="account.form.first_name" input-type="text" />
            <FormField v-model="user.last_name" i18n="account.form.last_name" input-type="text" />
            <FormField v-model="user.bio_text" i18n="account.form.bio_text" input-type="text" />
            <FormField v-model="user.bio_link" i18n="account.form.bio_link" input-type="text" />

            <FormField v-model="user.email" i18n="account.form.email" input-type="email" rules="required|email" />

            <FormField v-model="user.mobile_phone" i18n="account.form.mobile_phone" input-type="tel" />

            <div>
              <v-btn class="mr-6" color="primary" small @click="$refs.account.validate()">
                {{ $t("common.update") }}
              </v-btn>
              <v-btn class="mr-6" small @click="cancel">
                {{ $t("common.cancel") }}
              </v-btn>
            </div>
          </Form>
        </template>
        <template #rightWithOutHelp>
          <v-card>
            <v-list-item>
              <v-list-item-avatar class="tw-border tw-border-gray-600">
                <v-img
                  :src="
                    user.avatar
                      ? user.avatar
                      : 'https://cdn.securating.io/public/storage/shared/common/anonymous_avatar1.png'
                  "
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="headline">
                  {{ publicName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ publicCardName }}
                </v-list-item-subtitle>
                <span v-html="publicCardBio"></span>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <!-- More infos here... -->
            </v-card-text>
          </v-card>
        </template>
      </TabPage>
      <!-- ------------------------ secret ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="me/account/secret/page" name="secret">
        <template #content>
          <div class="tw-mb-6">{{ $t("account.secret.subtitle") }}</div>
          <v-text-field :value="user.code" class="tw-font-bold" readonly single-line>
            <template #append>
              <v-btn :title="$t('account.secret.reload')" icon @click="generateSecret">
                <v-icon color="error" small>fa-sync-alt</v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <v-btn class="tw-mt-6" color="error" small @click="generateSecret">
            {{ $t("account.secret.reload") }}
          </v-btn>
        </template>
      </TabPage>
      <!-- ------------------------ bookmarks / favoris ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="menu/user/bookmark/page" name="bookmark">
        <template #content>
          <Bookmarks />
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import { isset } from "@/helpers"
import { Types as TypesSnackbar } from "@/store/modules/snackbar"
import Bookmarks from "@/components/me/tabs/Account/Bookmarks";

export default {
  name: "Account",
  mixins: [tab],
  components: {
    Bookmarks,
  },
  data: () => ({
    user: {},
    valid: false,
    pages: ["user", "secret", "bookmark"],
    menu: "account",
    page: "user",
  }),
  mounted() {
    //-- In case the bookmark is requested setup the right page
    if (window.location.href.match(/bookmarks$/)) {
      this.page = "bookmark"
    }
    this.fetchUser()
  },
  computed: {
    publicName() {
      let aFirstName = ""
      if (isset(this.user.first_name) && this.user.first_name.length > 0) {
        aFirstName = this.user.first_name
      }
      let aFirstLastName = ""
      if (isset(this.user.last_name) && this.user.last_name.length > 0) {
        aFirstLastName = this.user.last_name
      }
      if (aFirstName.length > 0 || aFirstLastName.length > 0) {
        aFirstName = aFirstName.charAt(0).toUpperCase() + aFirstName.slice(1)
        aFirstLastName = aFirstLastName.toUpperCase()
        return `${aFirstName}
                ${aFirstLastName}`
      }
      return this.user.user_name
    },
    publicCardName() {
      let cardName = this.user.user_name
      if (this.publicName === cardName) {
        cardName = ""
      }
      if ("-" === cardName) {
        cardName = ""
      }
      let age = ""
      if (isset(this.user.birth_date) && this.user.birth_date.length) {
        let today = new Date()
        let year = today.getFullYear()
        age = year - this.user.birth_date.slice(0, 4)
        if (age > 40) {
          age = "40 ans voir +"
        } else {
          if (age >= 20) {
            age = "de 20 à 40 ans"
          } else {
            age = "pas encore 20 ans"
          }
        }
      }
      if (age !== "") {
        cardName = cardName + " (" + age + ")"
      }

      return cardName
    },
    publicCardBio() {
      let bio = ''
      if(this.user.bio_text&&this.user.bio_link){
        bio = '<a href="'+this.user.bio_link+'" tager="_blanc">'+this.user.bio_text+'</a>'
      } else {
        if(!this.user.bio_link){
          bio = this.user.bio_text
        } else {
          bio = '<a href="'+this.user.bio_link+'" tager="_blanc">'+this.user.bio_link+'</a>'
        }
      }
      return bio
    },
  },
  methods: {
    fetchUser() {
      return new Promise((resolve, reject) => {
        this.$axios
          .get("office/me/user/")
          .then(response => {
            this.user = response.data
            if(this.user.user_name.charAt(2)==':') {
              this.user.user_name = '';
            }
            resolve(this.user)
          })
          .catch(error => reject(error))
      })
    },
    generateSecret() {
      this.$axios.post("user/code").then(response => {
        this.user.code = response.data.code
      })
    },
    isImgUrl(url) {
      return this.isUrl(url) && this.isImg(url)
    },
    isUrl(url) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ) // fragment locator
      return !!pattern.test(url)
    },
    isImg(url) {
      return !!url.match(/\.(jpeg|jpg|gif|png)$/)
    },
    // Cancel the current modification on the user data
    cancel() {
      this.fetchUser()
    },
    updateUserAvatar(image) {
      this.user.avatar = image.url
      this.update()
    },
    // Update the current user
    update() {
      return new Promise((resolve, reject) => {
        this.$axios
          .put("/office/me/users", { ...this.user })
          .then(() => {
            this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
              lines: this.$t("account.form.update"),
              config: { timeout: 1000 * 6, color: "success" },
            })
            resolve()
          })
          .catch(errors => reject(errors.response.data))
      })
    },
  },
}
</script>
